// 서비스워커 등록 헬퍼 (CRA 표준 패턴 기반, 단순화)

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
);

export function register() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

      if (isLocalhost) {
        // 로컬 개발환경에서는 등록하지 않음 (캐시로 인한 개발 혼란 방지)
        return;
      }

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log("[PWA] 서비스워커 등록 완료:", registration.scope);
        })
        .catch((error) => {
          console.error("[PWA] 서비스워커 등록 실패:", error);
        });
    });
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
